import axios from "axios";

const headers = () => ({
  "ngrok-skip-browser-warning": "disabled",
  "Content-Type": "application/json",
});

export const startVrSession = async (payload) => {
  try {
    const API_URL = "/.netlify/functions/vr-session-start";
    const response = await axios.post(API_URL, payload, { headers: headers() });
    return response.data;
  } catch (error) {
    console.error("startVrSession failed:", error);
    throw error;
  }
};

export const completeVrSession = async (payload) => {
  try {
    const API_URL = "/.netlify/functions/vr-session-complete";
    const response = await axios.post(API_URL, payload, { headers: headers() });
    return response.data;
  } catch (error) {
    console.error("completeVrSession failed:", error);
    throw error;
  }
};
